import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";

function Email({ log }: Props) {
  const { t } = useTranslation();

  return (
    <p>
      {log.attributes.target !== "failure"
        ? t(
            `planzoneLogsPage.description.${log.content}.${log.attributes.target}`,
            { name: log.attributes.data },
          )
        : t(
            `planzoneLogsPage.description.${log.content}.${log.attributes.target}.${log.attributes.parent}`,
            { name: log.attributes.data },
          )}
    </p>
  );
}

export { Email };
